import { ReplaceableURL } from "../../components/Common/RegionawareLink";
import { ReplaceableKey } from "../../lib/helper/stringReplacer";
import { WootingCDN } from "./openGraph";
import { OrderItemsEntity } from "./types";

interface MapType {
  general: RecommendedArticle[];
  products: RecommendedItem[];
}

interface RecommendedArticle {
  id: ArticleID;
  url: ReplaceableURL;
  img: string;
  title: string;
  weight: number;
  labels?: string[];
}

interface RecommendedItem {
  skus: OrderItemsEntity["sku"][];
  articles: RecommendedArticle[];
}

export enum ArticleID {
  QuickStart = "quickstart",
  Warranty = "warranty",
}

const recommendedArticlesMap: MapType = {
  general: [
    {
      id: ArticleID.QuickStart,
      url: `${ReplaceableKey.WootingStoreURL}/quickstart`,
      img: WootingCDN.knowledgeBase,
      title: "Quickstart Guides",
      weight: 0,
    },
    {
      id: ArticleID.Warranty,
      url: `${ReplaceableKey.WootingStoreURL}/warrantyreturn`,
      img: WootingCDN.warranty,
      title: "Warranty Information",
      weight: 0,
    },
  ],
  products: [
    // Wooting Wrist Rests
    /* 
    // This wrist rest page is now deprecated, but we keep this definition for future reference.
    // If we ever want to add specific articles for any set of SKUs, we can do so here.
    {
      skus: [
        "WR1-367-BK-001",
        "WR1-367-BL-002",
        "WR1-367-GY-003",
        "WR2-445-BK-001",
        "WR2-445-BL-002",
        "WR2-445-BL-B02",
        "WR2-445-BK-B01",
        "WR1-367-BL-B01",
        "WR3-295-BK-001",
        "WR3-295-BL-002",
        "WR3-295-BL-B02",
        "WR3-295-BK-B01",
        "WR1-367-BK-B01",
      ],
      articles: [
        {
          url: `${ReplaceableKey.WootingStoreURL}/wrist_rest`,
          img: "https://cdn.shopify.com/s/files/1/0013/1383/3071/products/wrist-rest-top-black.jpg?v=1606814509",
          title: "Wooting Wrist Rest Page",
          weight: 0,
        },
      ],
    },
    */
  ],
};

export default recommendedArticlesMap;
